import React from 'react';
import { Route } from 'react-router-dom';
import { DashboardMain } from "../ui/dashboard/DashboardMain";

export const dashboardRoutes = [
    <Route path="/dashboard" element={<DashboardMain />} key="dashboard" />,
];

